import { useEffect, useState } from "react";
import SearchProduct from "components/SearchProduct";
import { SearchProvider } from "context/SearchContext";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDButton from "components/MDButton";
import MDBox from "components/MDBox";
import SearchCustomer from "components/SearchCustomer";
import MDModal from "components/MDModal";
import { statusOrders } from "constants/CodConstants";

const { AddShoppingCart, RemoveShoppingCart } = require("@mui/icons-material");
const { Typography, Card, CardContent, Button, IconButton, Grid, Icon } = require("@mui/material");
const { useOrder } = require("context/OrderContext");
const { useOrderProducts } = require("context/OrderProductsContext");

function Orders() {
  const [dataCustomer, setDataCustomer] = useState({});
  const { storeOrder, updateOrder, orderResponse } = useOrder();
  const {
    addProductsOrder,
    removeFromOrderProducts,
    totalPriceRetail,
    storeOrderProducts,
    orderProducts,
    setOrderProducts,
    loading,
    msg,
    isOpen,
    setIsOpen,
  } = useOrderProducts();

  const handleModal = () => setIsOpen(!isOpen);

  const closeSearchModal = () => {
    setIsOpen(false);
  };

  const removeProductInOrder = (index) => {
    removeFromOrderProducts(index);
  };

  const saveOrderProducts = async (Ordem, dataCustomer, orderProducts) => {
    const status = statusOrders[2].value;
    await updateOrder(Ordem["Ordem"].id, dataCustomer, status);
    storeOrderProducts(Ordem["Ordem"].id, orderProducts);
  };

  useEffect(() => {
    storeOrder();
  }, []);

  return (
    <DashboardLayout>
      {/* <DashboardNavbar /> */}
      <Typography variant="h5" gutterBottom>
        Ordem de Produtos
      </Typography>
      <SearchProvider>
        <Grid container sx={{ p: 6 }}>
          <Grid
            item
            xs={12}
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-around",
              alignItems: "center",
              backgroundColor: "#1976D2",
            }}
          >
            <SearchProduct setOrderProduct={setOrderProducts} />
            <SearchCustomer dataCustomer={dataCustomer} setDataCustomer={setDataCustomer} />
          </Grid>
        </Grid>
      </SearchProvider>
      <Typography variant="h5" gutterBottom>
        Carrinho
        {/* <IconButton color="secondary" onClick={() => saveOrder}>
          <removeProductInOrder />
        </IconButton> */}
      </Typography>
      {orderProducts.length === 0 ? (
        <Typography variant="body1">Carrinho vazio</Typography>
      ) : (
        orderProducts.map((item, index) => (
          <Card key={index} style={{ marginBottom: 10 }}>
            <CardContent
              sx={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}
            >
              <Typography>
                {item.name}
                {` - `}
                {item.priceRetail ? `R$ ${item.priceRetail}` : `Preço de produto não cadastrado!`}
              </Typography>
              <IconButton color="secondary" onClick={() => removeProductInOrder(index)}>
                <RemoveShoppingCart />
              </IconButton>
            </CardContent>
          </Card>
        ))
      )}
      <MDBox
        sx={{ display: "flex", flexDirection: "row", justifyContent: "space-around" }}
        style={{
          position: "fixed",
          bottom: 0,
          left: 0,
          width: "100%",
          background: "#fff",
          padding: "10px",
          borderTop: "1px solid #ddd",
          textAlign: "center",
        }}
      >
        <Typography variant="h10">Total: R${totalPriceRetail}</Typography>
        <MDButton
          onClick={() => saveOrderProducts(orderResponse, dataCustomer, orderProducts)}
          disabled={orderProducts.length == 0}
          variant="gradient"
          color="info"
        >
          <Icon>shopping_bag</Icon>&nbsp;Finalizar Compra
        </MDButton>
      </MDBox>
      <MDModal isOpen={isOpen} handleModal={handleModal}>
        <Typography id="modal-modal-description" sx={{ mt: 2 }}>
          {msg}
        </Typography>
        <MDButton variant="gradient" color="info" onClick={closeSearchModal} fullWidth>
          Fechar
        </MDButton>
      </MDModal>
    </DashboardLayout>
  );
}

export default Orders;
